import { cn } from '~/utils/cnTailwind.ts';

/**
 * Label styling for a sub-field (note, start date) that belongs to the field above it.
 * The indent stays inside the fixed label width, so the input keeps the alignment of the other rows.
 * The pseudo element is the elbow: it starts in the gap above and turns into the label text.
 */
export const subFieldLabelClassName = cn(
    'relative h-8 w-[230px] shrink-0 justify-start pl-8',
    "before:absolute before:-top-2 before:left-4 before:h-6 before:w-2.5 before:content-['']",
    'before:rounded-bl before:border-b before:border-l before:border-grey-outline-light',
);
